module.exports = __webpack_public_path__ + "img/6-min.96994e54.jpg";